import { render, staticRenderFns } from "./PvpBattleOverlay.vue?vue&type=template&id=11ba9a22&scoped=true"
import script from "./PvpBattleOverlay.vue?vue&type=script&lang=js"
export * from "./PvpBattleOverlay.vue?vue&type=script&lang=js"
import style0 from "./PvpBattleOverlay.vue?vue&type=style&index=0&id=11ba9a22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ba9a22",
  null
  
)

export default component.exports